// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Mixins
import {FormInput} from './../../../mixins/form_input/FormInput'

// Components
import {Icon} from './../icon/Icon'
import {Button} from './../button/Button'

@Component({
    name: 'InputList',
    components: {
        Icon,
        Button
    },
    mixins: [
        template,
    ]
})
export class InputList extends mixins(FormInput) {

    public get shouldDisplayPlaceholder() {

        return !this.hasValueInputFocus && this.value.length == 0
    }

    public get filteredErrors() {
        return this.displayErrors.filter(error => error != '' && error != undefined && error != null )
    }

    public get inputListClass() {
        return `${this.$appPrefix}-input-list--${this.theme ? this.theme : 'default'}`
    }

    public get disabledClass() {
        return this.disabled  ? `${this.$appPrefix}-input-list--disabled` : ''
    }

    public get errorClass() {
        return this.$slots['validation'] || this.filteredErrors.length > 0 ? `${this.$appPrefix}-input-list--has-error` : ''
    }

    public hasValueInputFocus: boolean = false

    // Input value
    public valueInput: string = ''

    @Prop([Array])
    public value!: any[]

    @Prop()
    public theme!: string

    @Prop([String, Number])
    public label?: any

    @Prop()
    public placeholder?: string

    @Prop()
    public disabled?: boolean

    @Prop({default: () => []})
    public displayErrors!: string[]

    @Prop({default: true})
    public showErrors!: boolean

    @Prop()
    public name!: string

    @Prop({default: "0"})
    public tabindex!: string

    @Prop({default: null})
    public limit!: number | null

    @Prop({default: false})
    public acceptCsv!: boolean
    // Types
    public $refs!: {
        head: HTMLElement
        valueInput: HTMLFormElement
    }

    get limitDisabled() {
        if (this.limit != null) {
            return this.value.length >= this.limit;
        } else {
            return false
        }
    }

    public created() {

        window.addEventListener('click', this.handleLoseFocus)
    }

    public destroyed() {

        window.removeEventListener('click', this.handleLoseFocus)
    }

    public handleRemoveInputValue(value: any) {

        let values = this.value

        if (values.includes(value)) {
            values.splice(values.indexOf(value), 1)
        }

        this.$refs.valueInput.focus()
        this.hasValueInputFocus = true

        this.$emit('input', values)
    }

    public handleAddInputValue() {

        if (this.valueInput.length == 0) return
        
        let values = this.value

        if (this.acceptCsv) {
            this.splitCsv(this.valueInput).forEach(val => values.push(val))
        } else {
            values.push(this.valueInput)
        }
        this.valueInput = ''
        this.$refs.valueInput.focus()
        this.hasValueInputFocus = true

        this.$emit('input', values)
    }

    public splitCsv(value: any) {
        let separateVal: any = [];

        if (value.includes(",")) {
            const splitValues = value
                .split(",")
                .map((tag) => tag.trim())
                .filter((tag) => tag.length !== 0);
            separateVal.push(...splitValues);
        } else {
            separateVal.push(value.trim());
        }

        return separateVal;
    }

    public handleSetValueInputFocus() {
        this.$refs.valueInput.focus()
        this.hasValueInputFocus = true
    }

    public handleValueInput(e: Event) {
        if (this.$refs.valueInput.offsetWidth < (this.$refs.head.offsetWidth - 52)) {
            this.$refs.valueInput.style.width = Math.min(
                ((this.valueInput.length + 1) * 8),
                (this.$refs.head.offsetWidth - 52)
            ) + 'px'
        }
    }

    public handleLoseFocus(e?: any) {

        if (!e || e.target.contains(this.$el) || !this.$el.contains(e.target!)) {

            this.valueInput = ''
            this.$refs.valueInput.blur()
            this.hasValueInputFocus = false
            this.$refs.valueInput.style.width = 1 + 'px'
        }
    }
}